import { render } from "./CaricamentoAnnullamentoPratica.vue?vue&type=template&id=24de2aaa"
import script from "./CaricamentoAnnullamentoPratica.vue?vue&type=script&lang=js"
export * from "./CaricamentoAnnullamentoPratica.vue?vue&type=script&lang=js"

import "./CaricamentoAnnullamentoPratica.vue?vue&type=style&index=0&id=24de2aaa&lang=css"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__